import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const UpgradeBarContainer = styled.div`
  background: linear-gradient(135deg, #1a365d 0%, #2563eb 100%);
  padding: 18px 28px;
  border-radius: 14px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  color: #ffffff;
  box-shadow: 0 8px 30px rgba(126, 34, 206, 0.2);
  font-weight: 500;
  letter-spacing: 0.3px;
  position: relative;
  overflow: hidden;
  animation: slideIn 0.5s ease-out;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, 
      rgba(255, 255, 255, 0.2) 0%, 
      rgba(255, 255, 255, 0.08) 100%
    );
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 24px;
    gap: 16px;
  }

  @keyframes slideIn {
    from { transform: translateX(-20px); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
`;

const UpgradeText = styled.span`
  font-size: 16px;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  color: #ffffff;
  z-index: 1;
  line-height: 1.4;
`;

const UpgradeButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 12px 28px;
  border-radius: 10px;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(8px);
  white-space: nowrap;
  font-size: 16px;
  z-index: 1;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
    border-color: rgba(255, 255, 255, 0.6);
  }

  &:active {
    transform: translateY(0);
  }
`;

const LightningIcon = styled.span`
  font-size: 20px;
  margin-right: 6px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  vertical-align: middle;
`;

const UpgradeBar = () => {
  const navigate = useNavigate();

  return (
    <UpgradeBarContainer>
      <UpgradeText>
        <LightningIcon>⚡</LightningIcon>
        You are currently on the Free Plan
      </UpgradeText>
      <UpgradeButton onClick={() => navigate('/pro-subscription')}>
        Upgrade to Pro
      </UpgradeButton>
      <UpgradeText>
        for unlimited features and advanced tools
      </UpgradeText>
    </UpgradeBarContainer>
  );
};

export default UpgradeBar; 